module.exports = __webpack_public_path__ + "static/media/Blokes-avatar-Nathan-transparent.99db6f5d.png";